import { useGetExpenseAttachment } from 'mmfintech-backend-api'
import type { ExpenseResponse } from 'mmfintech-backend-api/types'
import { useEffect, useState } from 'react'
import { PreviewFile, type PreviewFileProps } from './PreviewFile'

type PreviewFileExtendedProps = Omit<PreviewFileProps, 'file' | 'error' | 'isLoading'> & { expense: ExpenseResponse }

// noinspection JSUnusedGlobalSymbols
export const PreviewFileByExpense = ({ expense, ...props }: PreviewFileExtendedProps) => {
  const { getExpenseAttachment, expenseAttachmentError, expenseAttachmentFetching } = useGetExpenseAttachment()

  const [file, setFile] = useState(null)

  useEffect(() => {
    if (expense?.reportId && expense?.id) {
      getExpenseAttachment(expense.reportId, expense.id, (data: any, filename: string, contentType: string) => {
        const file = new File([data], filename || `expense-${expense.id}-attachment.pdf`, { type: contentType })
        setFile({
          fileUrl: URL.createObjectURL(file),
          type: file.type,
          fileName: file.name
        })
      })
    } else {
      setFile(null)
    }
  }, [expense?.id])

  return <PreviewFile {...props} file={file} error={expenseAttachmentError} isLoading={expenseAttachmentFetching} />
}
